import { useBreakpointValue } from '@chakra-ui/react';
import React from 'react';

import { DesktopCartSkeleton, MobileCartSkeleton } from './components';
import { useCartSkeletonData } from './hooks';

interface CartSkeletonProps {
  showMobileBackground?: boolean;
}

export const CartSkeleton = ({ showMobileBackground = false }: CartSkeletonProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { lineItems, maxVisibleItems } = useCartSkeletonData();

  if (isMobile) {
    return <MobileCartSkeleton showMobileBackground={showMobileBackground} />;
  }

  return (
    <DesktopCartSkeleton
      lineItems={lineItems}
      maxVisibleItems={maxVisibleItems}
    />
  );
};

